// Import necessary dependencies
import React from 'react';
import './Contact.css'; // Import CSS for styling
import contactBg from './image/contact.svg'; // Path to your contact background SVG
import Find from './Find'; // Import the Find component

const Contact = () => {
  return (
    <div className="contact-page">
      <img src={contactBg} alt="Contact Background" className="contact-bg" />
      <div className="contact-content">
        <div className="find-container">
          <Find /> {/* Include the Find component here */}
        </div>
      </div>
    </div>
  );
};

export default Contact;
